<template>
  <div class="page_legalSubjectInfo">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <el-form :inline="true" v-if="activeName == 'third'" class="re_down_form" label-width="120px" @submit.native.prevent>
          <el-form-item label="分支机构全称:">
            <el-input v-model="branchName" size="small" clearable @keyup.enter.native="GetSubsidiaryCompanyList()" style="width:350px;"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="top-right">
        <el-button type="success" size="small" v-if="activeName == 'third'" @click="GetSubsidiaryCompanyList" style="margin-right:24px">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>系统</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/legalMaintenance' }">法务主体维护</el-breadcrumb-item>
          <el-breadcrumb-item>新增/编辑法务主体</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="基础信息" name="first" v-if="checkPermission(['legalMaintenance_add_basic'], permissionLists)"></el-tab-pane>
          <el-tab-pane label="财务信息" name="second" :disabled="!legForm2.LegalId" v-if="checkPermission(['legalMaintenance_add_finance'], permissionLists)"></el-tab-pane>
          <el-tab-pane label="分支机构" name="third" v-if="checkPermission(['legalMaintenance_add_basic'], permissionLists)" :disabled="!legForm.Id"></el-tab-pane>
        </el-tabs>

        <div class="info_Box" v-if="activeName == 'first'">
          <div class="flex">
            <div class="legForm">
              <el-form :model="legForm" :rules="rules" ref="legForm" label-width="106px">
                <el-form-item label="法务主体属性" v-if="!this.legForm.Id">
                  <el-select v-model="legType" style="width: 300px;" placeholder="" clearable filterable>
                    <el-option value="独立公司"></el-option>
                    <el-option value="分公司"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="母公司" v-if="!this.legForm.Id && legType == '分公司'" prop="parentCompany">
                  <el-select v-model="legForm.parentCompany" style="width: 300px;" placeholder="" clearable filterable @change="changeLeg">
                    <el-option v-for="(item, index) in allLegList" :key="index" :label="item.CompanyName" :value="item.Id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="公司名称" prop="CompanyName">
                  <el-input v-model="legForm.CompanyName"></el-input>
                </el-form-item>
                <el-form-item label="公司类型">
                  <el-radio-group v-model="legForm.SubType">
                    <el-radio :label="0">内部主体</el-radio>
                    <el-radio :label="1">外部主体</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="注册资金" prop="RegisteredCapital">
                  <div class="unit flex">
                    <el-input v-model="legForm.RegisteredCapital" :disabled="noFund"></el-input>
                    <div style="margin-left: 10px;">万</div>
                    <el-checkbox v-model="noFund" style="margin-left: 10px;">分公司无注册资金</el-checkbox>
                  </div>
                </el-form-item>
                <el-form-item label="企业信用代码" prop="TaxNum">
                  <el-input v-model="legForm.TaxNum"></el-input>
                </el-form-item>
                <el-form-item label="注册地点" prop="RegisteredAddress">
                  <div class="address flex">
                    <el-cascader ref="regAddress" :props="propsAddress" v-model="area" :options="provinces" filterable @change="changeAddress"></el-cascader>
                    <el-input v-model="address" style="margin-left: 10px;width: 180px;"></el-input>
                  </div>
                </el-form-item>
                <el-form-item label="注册时间" prop="RegisteredTime">
                  <el-date-picker type="date" placeholder="选择日期" v-model="legForm.RegisteredTime"></el-date-picker>
                </el-form-item>
                <el-form-item label="营业期限" prop="BusinessTerm">
                  <el-date-picker type="date" placeholder="选择日期" v-model="legForm.BusinessTerm" :disabled="longterm"></el-date-picker>
                  <el-checkbox v-model="longterm" style="margin-left: 10px;">长期有效</el-checkbox>
                </el-form-item>
                <el-form-item label="经营范围" prop="BusinessScope">
                  <el-input type="textarea" v-model="legForm.BusinessScope" :autosize="{ minRows: 4 }"></el-input>
                </el-form-item>
                <el-form-item label="股东结构" prop="ShareholderStruct">
                  <el-input type="textarea" v-model="legForm.ShareholderStruct" :autosize="{ minRows: 4 }"></el-input>
                </el-form-item>
                <el-form-item label="说明" prop="Explain">
                  <el-input type="textarea" v-model="legForm.Explain" :autosize="{ minRows: 4 }" maxlength="500" show-word-limit></el-input>
                </el-form-item>
              </el-form>
            </div>
            <div class="legForm" style="margin-left: 50px;">
              <el-form :model="legForm" :rules="rules" ref="legForm2" label-width="100px">
                <el-form-item label="公司状态" prop="CompanyStuat">
                  <div style="padding-left: 15px;">
                    <el-switch v-model="legForm.CompanyStuat" active-value="启用" inactive-value="停止" active-text="启用" inactive-text="停止" active-color="#19bd92"></el-switch>
                  </div>
                </el-form-item>
                <el-form-item label="业务类型" prop="BusinessUnit">
                  <el-select v-model="legForm.BusinessUnit" placeholder="" clearable multiple>
                    <el-option label="外包" value="外包"></el-option>
                    <el-option label="派遣" value="派遣"></el-option>
                    <el-option label="代理招聘" value="代理招聘"></el-option>
                    <el-option label="猎头" value="猎头"></el-option>
                    <el-option label="产业园" value="产业园"></el-option>
                    <el-option label="退役军人" value="退役军人"></el-option>
                    <el-option label="其他" value="其他"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="公司属性" prop="CompanyPro">
                  <el-select v-model="legForm.CompanyPro" placeholder="" clearable>
                    <el-option label="独资" value="独资"></el-option>
                    <el-option label="合资" value="合资"></el-option>
                    <el-option label="分公司" value="分公司"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="法人/负责人" prop="LegalPerson">
                  <el-select v-model="legForm.LegalPerson" value-key="Userid" placeholder="" clearable filterable allow-create>
                    <el-option v-for="(item, index) in personnelList" :key="index" :label="item.Username" :value="item.Username"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="资质管理员" prop="QualificationManager">
                  <el-select v-model="legForm.QualificationManager" value-key="Userid" placeholder="" clearable filterable @change="val => { changePerson(val, 'QualificationManager', 'QualificationManagerid') }">
                    <el-option v-for="(item, index) in personnelList" :key="index" :label="item.Username" :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="公章管理员" prop="StampKeepername">
                  <el-select v-model="legForm.StampKeeper" value-key="Userid" placeholder="" clearable filterable @change="val => { changePerson(val, 'StampKeeper', 'StampKeeperID') }">
                    <el-option v-for="(item, index) in personnelList" :key="index" :label="item.Username" :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="合同章管理员" prop="ContractSealKeeper">
                  <el-select v-model="legForm.ContractSealKeeper" value-key="Userid" placeholder="" clearable filterable @change="val => { changePerson(val, 'ContractSealKeeper', 'ContractSealKeeperid') }">
                    <el-option v-for="(item, index) in personnelList" :key="index" :label="item.Username" :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="注册公司名称">
                  <el-input v-model="legForm.realCompanyName"></el-input>
                </el-form-item>
                <!-- <el-form-item label="法人身份证保管员" prop="CorporIdcardKeeper">
                  <el-select v-model="legForm.CorporIdcardKeeper" value-key="Userid" placeholder="" clearable filterable @change="val=>{changePerson(val,'CorporIdcardKeeper','CorporIDCardKeeperid')}">
                    <el-option v-for="(item,index) in personnelList" :key="index" :label="item.Username" :value="item"></el-option>
                  </el-select>
                </el-form-item> -->
              </el-form>
            </div>
          </div>

          <div>
            <div class="info_Item_Title f_form" style="margin-bottom: 10px">
              开票信息
            </div>
            <div class="flex">
              <div class="legForm">
                <el-form :model="legForm" label-width="80px">
                  <el-form-item label="税号">
                    <el-input v-model="legForm.TaxNum"></el-input>
                  </el-form-item>
                  <el-form-item label="开票地址" prop="BillingAdd">
                    <!-- <el-input v-model="legForm.BillingAdd"></el-input> -->
                    <div class="address flex">
                      <el-cascader ref="regAddress2" :props="propsAddress" v-model="area" :options="provinces" filterable @change="changeAddress"></el-cascader>
                      <el-input v-model="address" style="margin-left: 10px;width: 180px;"></el-input>
                    </div>
                  </el-form-item>
                  <el-form-item label="开票电话" prop="BillingTel">
                    <el-input v-model="legForm.BillingTel"></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div class="legForm">
                <el-form :model="legForm" label-width="80px">
                  <el-form-item label="开户行" prop="BillingBank">
                    <el-input v-model="legForm.BillingBank"></el-input>
                  </el-form-item>
                  <el-form-item label="银行账号" prop="BillingAccount">
                    <el-input v-model="legForm.BillingAccount"></el-input>
                  </el-form-item>
                  <el-form-item label="联行号" prop="BillingCnaps">
                    <el-input v-model="legForm.BillingCnaps"></el-input>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </div>

          <div>
            <div class="info_Item_Title f_form" style="margin-bottom: 10px">
              资料管理
            </div>
            <el-table :data="zjTable" border class="doc_table" style="width: 621px;">
              <el-table-column prop="name" label="名称" width="160" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="has" label="有无" width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="dateDue" label="到期时间" width="110" :show-overflow-tooltip="true" align="center">
                <template slot-scope="scope">
                  {{ scope.row.dateDue ? scope.row.dateDue.indexOf('2999-12-31')>-1 ? '长期有效' : scope.row.dateDue.split('T')[0] : '' }}
                </template>
              </el-table-column>
              <el-table-column prop="Url" label="附件" width="100" align="center">
                <template slot-scope="scope">
                  <div class="info_item_sys cp" v-if="scope.row.Url" @click="down(scope.row.Url)">下载</div>
                  <div v-else>暂无附件</div>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="150" align="center">
                <template slot-scope="scope">
                  <div class="flex" style="justify-content: center;">
                    <span class="info_item_sys cp" style="margin-right: 10px;" @click="editZJ(scope.row, scope.$index)" v-if="scope.$index > 1">编辑</span>
                    <el-upload class="table_upload" action="" :on-change="(file, fileList) => { handleChangeUploadZJ(file, fileList, scope.$index) }" :auto-upload="false" :show-file-list="false" :multiple="false">
                      <div class="info_item_sys">{{ scope.row.Url ? '更新' : '上传' }}</div>
                    </el-upload>
                    <span class="info_item_sys cp" style="margin-left: 10px;" @click="delZJUrl(scope.$index)" v-if="scope.row.Url">删除附件</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div style="margin-top: 30px;">
            <div class="info_Item_Title f_form" style="margin-bottom: 10px">
              其他资质
            </div>
            <el-table :data="legForm.filelist" border class="doc_table" style="width: 511px;">
              <el-table-column prop="FileType" label="名称" width="260" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <!-- <el-table-column prop="UpdataTime" label="更新时间" width="160" align="center">
                <template slot-scope="scope">
                  {{ scope.row.UpdataTime!=undefined && scope.row.UpdataTime ? scope.row.UpdataTime.replace('T',' ') : ''}}
                </template>
              </el-table-column> -->
              <el-table-column prop="Url" label="附件" width="100" align="center">
                <template slot-scope="scope">
                  <div class="info_item_sys cp" v-if="scope.row.Url" @click="down(scope.row.Url)">下载</div>
                  <div v-else>暂无附件</div>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="操作" width="150" align="center">
                <template slot-scope="scope">
                  <div class="flex" style="justify-content: center;">
                    <el-upload class="table_upload" action="" :on-change="(file, fileList) => { handleChangeUpload(file, fileList, scope.$index) }" :auto-upload="false" :show-file-list="false" :multiple="false">
                      <div class="info_item_sys">{{ scope.row.Url ? '更新' : '上传' }}</div>
                    </el-upload>
                    <span class="info_item_sys cp" style="margin-left: 10px;" @click="delUrl(scope.row)" v-if="scope.row.Url">删除附件</span>
                    <span class="info_item_sys cp" style="margin-left: 10px;" @click="del(scope.$index)">删除</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="greenName cp" style="width: 73px;" @click="addZZ">+新增资质</div>
          </div>
          <div class="btnBox">
            <el-button type="success" v-preventReClick @click="submitForm" :disabled="isSuccess" :loading="isBtnLoading">保存</el-button>
            <el-button @click="backHandle">返回</el-button>
          </div>
        </div>

        <div class="info_Box" v-if="activeName == 'second'">
          <div class="flex">
            <div class="flex">
              <div class="legForm">
                <el-form :model="legForm2" :rules="rules" ref="finance" label-width="90px">
                  <el-form-item label="主体名称">
                    <el-input v-model="legForm.CompanyName" readonly disabled></el-input>
                  </el-form-item>
                  <el-form-item label="纳税人分类" prop="TaxpayerClass">
                    <el-select v-model="legForm2.TaxpayerClass" placeholder="" clearable>
                      <el-option label="一般纳税人" value="一般纳税人"></el-option>
                      <el-option label="小规模" value="小规模"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="报税会计" prop="TaxAccounting">
                    <el-select v-model="legForm2.TaxAccounting" value-key="Userid" placeholder="" clearable filterable @change="val => { changePerson2(val, 'TaxAccounting', 'TaxAccountingid') }">
                      <el-option v-for="(item, index) in personnelList" :key="index" :label="item.Username" :value="item"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="开票负责人" prop="BillingOfficer">
                    <el-select v-model="legForm2.BillingOfficer" value-key="Userid" placeholder="" clearable filterable @change="val => { changePerson2(val, 'BillingOfficer', 'BillingOfficerid') }">
                      <el-option v-for="(item, index) in personnelList" :key="index" :label="item.Username" :value="item"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="财报/审计报告管理员" prop="FinancialStatEkeeper">
                    <el-select v-model="legForm2.FinancialStatEkeeper" value-key="Userid" placeholder="" clearable filterable @change="val => { changePerson2(val, 'FinancialStatEkeeper', 'FinancialStatEkeeperid') }">
                      <el-option v-for="(item, index) in personnelList" :key="index" :label="item.Username" :value="item"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="说明" prop="Explain">
                    <el-input type="textarea" v-model="legForm2.Explain" :autosize="{ minRows: 4 }" maxlength="500" show-word-limit></el-input>
                  </el-form-item>

                  <!-- <el-form-item label="开票类型" prop="BillingType">
                    <el-select v-model="BillingType" placeholder="" clearable multiple>
                      <el-option label="全额" value="全额"></el-option>
                      <el-option label="差额" value="差额"></el-option>
                      <el-option label="都可" value="都可"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="开票内容" prop="BillingContent">
                    <el-select v-model="BillingContent" placeholder="" clearable multiple>
                      <el-option label="服务费发票" value="服务费发票"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="适用税率" prop="TaxRate">
                    <el-select v-model="legForm2.TaxRate" placeholder="" clearable>
                      <el-option label="3%" value="3%"></el-option>
                      <el-option label="6%" value="6%"></el-option>
                      <el-option label="6.72%" value="6.72%"></el-option>
                    </el-select>
                  </el-form-item> -->

                  <el-table :data="tableData" border class="doc_table" style="width: 391px;">
                    <el-table-column prop="Name" label="方案名称" width="100" :show-overflow-tooltip="true" align="center">
                    </el-table-column>
                    <el-table-column prop="BillingType" label="开票类型" width="100" :show-overflow-tooltip="true" align="center">
                    </el-table-column>
                    <el-table-column prop="BillingContent" label="开票内容" width="100" :show-overflow-tooltip="true" align="center">
                    </el-table-column>
                    <el-table-column prop="TaxRate" label="适用税率" width="90" :show-overflow-tooltip="true" align="center">
                    </el-table-column>
                  </el-table>

                  <div class="greenName cp" @click="addNew" style="width: 73px;">+添加新方案</div>
                </el-form>
              </div>
            </div>
            <div>
              <el-form :model="legForm2" :rules="rules" ref="finance2" label-width="90px">
                <!-- <el-form-item label="开票资料" prop="BillingInfor">
                  <el-input type="textarea" v-model="legForm2.BillingInfor" :autosize="{ minRows: 4}" maxlength="500" show-word-limit></el-input>
                </el-form-item> -->
                <!-- <el-form-item label="基本户"> -->
                <div>
                  <div class="bankTitle">基本户</div>
                  <div class="flex aic bankInfo">
                    <div class="bankInfo_title">开户行</div>
                    <el-input v-model="legForm2.BaOpenBank" style="width: 140px;"></el-input>
                    <div class="bankInfo_title">账号</div>
                    <el-input v-model="legForm2.BaAccount" style="width: 140px;"></el-input>
                    <el-checkbox v-model="legForm2.BakIsDaf" style="margin-left: 10px;">是否缺省</el-checkbox>
                    <el-checkbox v-model="legForm2.BaIsShow">是否隐藏</el-checkbox>
                  </div>
                </div>
                <!-- </el-form-item> -->

                <div class="bankTitle">一般户</div>
                <div style="margin-bottom: 20px;">
                  <div class="flex aic bankInfo" v-for="(item, index) in legForm2.CommonAccount" :key="index">
                    <div class="bankInfo_title">开户行</div>
                    <el-input v-model="item.BaOpenBank" style="width: 140px;"></el-input>
                    <div class="bankInfo_title">账号</div>
                    <el-input v-model="item.BaAccount" style="width: 140px;"></el-input>
                    <el-checkbox v-model="item.BakIsDaf" style="margin-left: 10px;">是否缺省</el-checkbox>
                    <el-checkbox v-model="item.BaIsShow">是否隐藏</el-checkbox>
                  </div>
                  <div class="greenName cp" @click="addHu" style="width: 73px;">+添加一般户</div>
                </div>

                <el-form-item label="审计报告" label-width="68px">
                  <el-upload class="table_upload" action="" :on-change="handleChangePic6" :limit="1" :on-exceed="handleExceed" :auto-upload="false" :file-list="PicList6" :multiple="false">
                    <el-button v-preventReClick type="primary" size="small">上传</el-button>
                  </el-upload>
                </el-form-item>

                <el-form-item label="返税政策" label-width="68px">
                  <el-upload class="table_upload" action="" :on-change="handleChangePic5" accept=".pdf" :limit="1" :on-exceed="handleExceed" :auto-upload="false" :file-list="PicList5" :multiple="false">
                    <el-button v-preventReClick type="primary" size="small">上传</el-button>
                  </el-upload>
                </el-form-item>
              </el-form>

              <!-- <div class="flex" style="width: 470px;">
                <div class="yyzz" style="width: 90px;">返税政策</div>
                <el-upload action="" list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="handleRemovePic5" :on-change="handleChangePic5" :on-exceed="handleExceedPic" :auto-upload="false" :multiple="false" :limit="1" :file-list="PicList5">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisiblePic">
                  <img width="100%" :src="dialogImageUrl" alt="" />
                </el-dialog>
                <el-upload class="table_upload" action="" :on-change="handleChangePic5" accept=".pdf" :limit="1" :on-exceed="handleExceed" :auto-upload="false" :file-list="PicList5" :multiple="false">
                  <el-button v-preventReClick type="primary" size="small">上传</el-button>
                </el-upload>
              </div> -->
            </div>
          </div>
          <div class="btnBox">
            <el-button type="success" v-preventReClick @click="saveForm" :disabled="isSuccess">保存</el-button>
            <el-button @click="backHandle">返 回</el-button>
          </div>

          <div style="margin-top: 30px;">
            <el-form :inline="false" :model="formData" label-width="110px">
              <div class="bankTitle">财务人员设置</div>


              <el-form-item label="开票会计">
                <el-radio v-model="formData2.model.BillingIn" label="1" @change="changeRadio">内部</el-radio>
                <el-select v-model="formData2.BillingInValJ" value-key="Userid" placeholder="" clearable filterable multiple style="margin-right: 30px;" v-if="formData2.model.BillingIn == '1'">
                  <el-option v-for="(item, index) in personnelList" :key="index" :label="item.Username" :value="item"></el-option>
                </el-select>
                <el-radio v-model="formData2.model.BillingIn" label="2" @change="changeRadio">代理</el-radio>
                <el-select v-model="formData2.BillingAgentValJ" value-key="Userid" multiple placeholder="" clearable filterable v-if="formData2.model.BillingIn == '2'">
                  <el-option v-for="(item, index) in personnelList" :key="index" :label="item.Username" :value="item"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="核算会计" prop="name">
                <el-radio v-model="formData2.model.InternalAccounting" label="1" @change="changeRadio2">内部</el-radio>
                <el-select v-model="formData2.InternalAccountingValJ" value-key="Userid" multiple placeholder="" clearable filterable v-if="formData2.model.InternalAccounting == '1'" style="margin-right: 30px;">
                  <el-option v-for="(item, index) in personnelList" :key="index" :label="item.Username" :value="item"></el-option>
                </el-select>
                <el-radio v-model="formData2.model.InternalAccounting" label="2" @change="changeRadio2">代理</el-radio>
                <el-select v-model="formData2.InternalAccountingAgentValJ" value-key="Userid" placeholder="" multiple clearable filterable v-if="formData2.model.InternalAccounting == '2'">
                  <el-option v-for="(item, index) in personnelList" :key="index" :label="item.Username" :value="item"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="财务经理" prop="name">
                <el-select v-model="formData2.FinancialManagerJ" value-key="Userid" placeholder="" multiple clearable filterable>
                  <el-option v-for="(item, index) in personnelList" :key="index" :label="item.Username" :value="item"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="出纳" prop="name">
                <div class="CashierBox flex" v-for="(item, index) in formData2.CashierJ" :key="index">
                  <el-select v-model="item.Username" value-key="Userid" placeholder="" clearable filterable @change="val => { changeCashier(val, index) }">
                    <el-option v-for="(item, index) in personnelList" :key="index" :label="item.Username" :value="item"></el-option>
                  </el-select>
                  <el-select v-model="item.CashierType" value-key="Userid" placeholder="" clearable style="margin-left: 20px;">
                    <el-option value="薪资业务"></el-option>
                    <el-option value="暂支打款"></el-option>
                    <el-option value="暂支核销"></el-option>
                    <el-option value="日志报销"></el-option>
                    <el-option value="其他业务"></el-option>
                  </el-select>
                  <div class="injuryTabBtn" style="margin-left:20px">
                    <el-button type="text" @click="delCashier(index)" v-if="formData2.CashierJ.length > 1">删除</el-button>
                    <el-button type="text" @click="addCashier" v-if="index == formData2.CashierJ.length - 1">新增</el-button>
                  </div>
                </div>

              </el-form-item>

              <div class="bankTitle">第三方系统帐号设置</div>

              <el-form-item label="薪福通个税帐号" prop="name">
                <div class="flex">
                  <div class="formTitle">申报密码</div>
                  <el-input v-model="formData2.model.DeclarationCode" style="width: 140px;margin-right: 30px;"></el-input>
                  <div class="formTitle">登记序号</div>
                  <el-input v-model="formData2.model.RegistrationNum" style="width: 140px;margin-right: 30px;"></el-input>
                  <el-button type="success" @click="getSerial">点击获取</el-button>
                </div>
              </el-form-item>
              <el-form-item label="财资系统客户号" prop="name">
                <el-input v-model="formData2.model.SystemCustomerNum" style="width: 221px;"></el-input>
              </el-form-item>

              <div class="bankTitle">银行帐户信息</div>
              <div class="bankBox">
                <div v-for="(item, index) in formData2.BankAccountJ" :key="index" style="margin-bottom: 15px;">
                  <div class="flex bankAccoutBox">
                    <el-input v-model="item.AccountName" placeholder="户名" style="width: 140px;margin-right: 10px;" size="small"></el-input>
                    <el-input v-model="item.BankName" placeholder="银行" style="width: 90px;margin-right: 10px;" size="small"></el-input>
                    <el-input v-model="item.OpeningBank" placeholder="开户行" style="width: 140px;margin-right: 10px;" size="small"></el-input>
                    <el-input v-model="item.Account" placeholder="银行账号" style="width: 140px;margin-right: 10px;" size="small"></el-input>
                    <el-checkbox v-model="item.IsBasic" :true-label="1" :false-label="0">基本户</el-checkbox>
                    <el-checkbox v-model="item.IsSalary" :true-label="1" :false-label="0">允许发薪</el-checkbox>
                    <el-checkbox v-model="item.IntPay" :true-label="1" :false-label="0">内部支付</el-checkbox>
                    <el-checkbox v-model="item.IsDefault" :true-label="1" :false-label="0">缺省帐户</el-checkbox>
                    <el-checkbox v-model="item.IsCbs" :true-label="1" :false-label="0">CBS账户</el-checkbox>
                    <div class="injuryTabBtn" style="margin-left: 15px;">
                      <el-button type="text" @click="delbankItem(index)" v-if="formData2.BankAccountJ.length > 1">删除</el-button>
                      <el-button type="text" @click="addLinkage(index)">添加联动代发账号</el-button>
                      <el-button type="text" @click="addbankItem" v-if="index == formData2.BankAccountJ.length - 1">新增</el-button>
                    </div>
                  </div>
                  <!-- 联动账号 -->
                  <div v-if="item.LinkageList != undefined && item.LinkageList.length > 0">
                    <div v-for="(k, i) in item.LinkageList" :key="i" style="margin:10px 0 0 30px">
                      <el-input v-model="k.AccountName" placeholder="户名" size="mini" style="width: 140px;margin-right: 30px;"></el-input>
                      <el-input v-model="k.BankName" placeholder="银行" size="mini" style="width: 140px;margin-right: 30px;"></el-input>
                      <el-input v-model="k.OpeningBank" placeholder="开户行" size="mini" style="width: 140px;margin-right: 30px;"></el-input>
                      <el-input v-model="k.Account" placeholder="银行账号" size="mini" style="width: 140px;margin-right: 10px;"></el-input>
                      <el-button type="text" @click="delLinkageItem(index, i)">删除联动账号</el-button>
                    </div>
                  </div>
                </div>
              </div>
            </el-form>
          </div>

          <div class="btnBox">
            <el-button type="success" v-preventReClick @click="confirmAddSalary">保存</el-button>
            <el-button @click="backHandle">返 回</el-button>
          </div>
        </div>

        <div class="info_Box" v-if="activeName == 'third'">
          <div class="ftabBtn flex">
            <el-button type="success" size="small" @click="addBranch">新增分支机构</el-button>
            <el-button type="primary" size="small" @click="exportHandle" :loading="isExping">导出</el-button>
          </div>
          <el-table :data="jgList" :max-height="tableHeight-210" style="width: 99%" border class="doc_table" v-loading="loading">
            <el-table-column label="序号" width="60" :show-overflow-tooltip="true" align="center" fixed="left">
              <template slot-scope="{$index}">
                {{ $index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="companyName" label="分支机构全称" width="266" :show-overflow-tooltip="true" align="center" fixed="left">
            </el-table-column>
            <el-table-column prop="registeredAddress" label="注册地区" width="180" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="registeredTime" label="成立时间" width="100" align="center">
              <template slot-scope="scope">
                {{ scope.row.registeredTime ? scope.row.registeredTime.split('T')[0] : '' }}
              </template>
            </el-table-column>
            <el-table-column prop="legalPerson" label="法人/负责人" width="100" align="center">
            </el-table-column>
            <el-table-column prop="isSsaccount" label="社保户" width="100" align="center">
            </el-table-column>
            <el-table-column prop="isAfund" label="公积金户" width="100" align="center">
            </el-table-column>
            <el-table-column prop="businessTerm" label="营业期限" width="140" align="center">
              <template slot-scope="{row}">
                <span :class="row.businessTerm && row.businessTerm < 180 ? 'warning' : ''">{{ row.businessTerm ?
                  row.businessTerm == '长期有效' ? row.businessTerm : row.businessTerm > 0 ? '剩余' +
                    Math.ceil(row.businessTerm) + '天' : '已过期' + Math.ceil(-row.businessTerm) + '天' : '' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="hasHumanResoLicen" label="人力资源证" width="100" align="center">
            </el-table-column>
            <el-table-column prop="hasHumanResoLicen" label="人力资源证附件" width="120" align="center">
              <template slot-scope="scope">
                <span class="greenName cp" v-if="scope.row.humanResoLicenUrl" @click="down(scope.row.humanResoLicenUrl)">下载</span>
              </template>
            </el-table-column>
            <el-table-column prop="humanResoLicenEndTime" label="人力资源证到期时间" width="140" align="center">
              <template slot-scope="{row}">
                <span :class="row.humanResoLicenEndTime && row.humanResoLicenEndTime < 180 ? 'warning' : ''">{{
                  row.humanResoLicenEndTime ? row.humanResoLicenEndTime > 0 ? '剩余' +
                    Math.ceil(row.humanResoLicenEndTime)
                    + '天' : '已过期' + Math.ceil(-row.humanResoLicenEndTime) + '天' :
                    '' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="hasLaborlicense" label="劳务派遣证" width="100" align="center">
            </el-table-column>
            <el-table-column prop="laborlicenseUrl" label="劳务派遣证附件" width="120" align="center">
              <template slot-scope="scope">
                <span class="greenName cp" v-if="scope.row.LaborlicenseUrl" @click="down(scope.row.laborlicenseUrl)">下载</span>
              </template>
            </el-table-column>
            <el-table-column prop="laborlicenseEndTime" label="劳务派遣证到期时间" width="140" align="center">
              <template slot-scope="{row}">
                <span :class="row.laborlicenseEndTime && row.laborlicenseEndTime < 180 ? 'warning' : ''">{{
                  row.laborlicenseEndTime ? row.laborlicenseEndTime > 0 ? '剩余' + Math.ceil(row.laborlicenseEndTime) +
                    '天'
                    : '已过期' + Math.ceil(-row.laborlicenseEndTime) + '天' : '' }}</span>
              </template>
            </el-table-column>
            <el-table-column fixed="right" prop="name" label="操作" width="80" align="center">
              <template slot-scope={row}>
                <div class="injuryTabBtn">
                  <el-popconfirm title="请确认是否删除" @confirm="delBranch(row)" style="margin-left:10px;">
                    <el-button type="text" slot="reference">删除</el-button>
                  </el-popconfirm>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

      </div>

      <el-dialog title="新增资质" :visible.sync="showAddSys" width="400px">
        <el-form :model="formData" ref="caseForm" label-width="80px">
          <el-form-item label="名称" prop="FileType">
            <el-input v-model="FileType" style="width: 221px;"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showAddSys = false" size="small">取消</el-button>
          <el-button type="primary" v-preventReClick size="small" @click="confirmAddSys">确定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="编辑证件资料" :visible.sync="showEditZJ" width="500px">
        <el-form :model="zjTable[ZJIndex]" ref="ZJForm" label-width="80px">
          <el-form-item label="名称" prop="name">
            <el-input v-model="zjTable[ZJIndex].name" style="width: 221px;" readonly disabled></el-input>
          </el-form-item>
          <el-form-item label="有无" prop="has">
            <el-select v-model="zjTable[ZJIndex].has" style="width: 221px;" placeholder="" clearable>
              <el-option value="有"></el-option>
              <el-option value="无"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="到期时间" prop="FileType" v-if="ZJIndex > 1">
            <div class="r_flex">
              <el-date-picker type="date" placeholder="选择日期" v-model="zjTable[ZJIndex].dateDue" :disabled="isLongCheck" value-format="yyyy-MM-dd"></el-date-picker>
              <el-checkbox v-model="isLongCheck" @change="longChange" style="margin-left: 5px;">长期有效</el-checkbox>
            </div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showEditZJ = false" size="small">取消</el-button>
          <el-button type="primary" v-preventReClick size="small" @click="confirmEditZJ">确定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="新增方案" :visible.sync="showAdd" width="500px">
        <el-form :model="formData" ref="caseForm" label-width="80px">
          <el-form-item label="方案名称" prop="Name">
            <el-input v-model="formData.Name" style="width: 221px;"></el-input>
          </el-form-item>
          <el-form-item label="开票类型" prop="BillingType">
            <el-input v-model="formData.BillingType" style="width: 221px;"></el-input>
          </el-form-item>
          <el-form-item label="开票内容" prop="BillingContent">
            <el-input v-model="formData.BillingContent" style="width: 221px;"></el-input>
          </el-form-item>
          <el-form-item label="适用税率" prop="TaxRate">
            <el-input v-model="formData.TaxRate" style="width: 221px;"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showAdd = false" size="small">取消</el-button>
          <el-button type="primary" size="small" @click="confirmAdd">确定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="新增分支机构" :visible.sync="showAddbranch" width="550px">
        <el-form label-width="80px">
          <el-form-item label="分支机构">
            <el-select v-model="branch" style="width: 400px;" placeholder="" clearable filterable>
              <el-option v-for="(item, index) in allLegList" :key="index" :label="item.CompanyName" :value="item.Id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showAddbranch = false" size="small">取消</el-button>
          <el-button type="primary" size="small" @click="confirmAddbranch" :loading="isBtnLoading">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      var validatetAddress = (rule, value, callback) => {
        if (!this.area && !this.legForm.RegisteredAddress) {
          callback(new Error("请选择省市区"));
        } else if (!this.address) {
          callback(new Error("请输入详细地址"));
        } else {
          callback();
        }
      };
      var validatetTerm = (rule, value, callback) => {
        if (!this.legForm.BusinessTerm && !this.longterm) {
          callback(new Error("请选择营业期限"));
        } else {
          callback();
        }
      };
      var validatetFund = (rule, value, callback) => {
        if (!this.legForm.RegisteredCapital && !this.noFund) {
          callback(new Error("请输入注册资金"));
        } else {
          callback();
        }
      };
      return {
        activeName: 'first',
        tableData: [],
        type: 'add',
        legForm: { //基本信息
          Id: '',
          Legalsubid: '',
          CompanyName: '', //公司名称
          RegisteredCapital: '', //注册资金
          RegisteredAddress: '', //注册地点
          RegisteredTime: '', //注册时间
          BusinessTerm: '', //营业期限
          BusinessScope: '', //经营范围
          Explain: '', //说明
          CompanyStuat: '', //公司状态
          BusinessUnit: [], //业务类型
          CompanyPro: '', //公司属性
          LegalPerson: '', //法人/负责人
          LegalPersonId: '',
          QualificationManager: '', //资质管理员
          QualificationManagerid: '',
          StampKeeper: '', //公章保管员
          StampKeeperID: '',
          ContractSealKeeper: '', //合同章管理员
          ContractSealKeeperid: '',
          // CorporIdcardKeeper: '', //法人身份证保管员
          // CorporIDCardKeeperid: '',
          BusiLicenseUrl: '', //营业执照
          OpenLicenseUrl: '', //开户许可证url
          HumanResoLicenUrl: '', //人力资源许可证
          LaborlicenseUrl: '', //劳务许可证
          HumanResoLicenEndTime: '', //人力资源许可证到期时间
          LaborlicenseEndTime: '', //劳务许可证到期时间
          TaxNum: '', //税号
          BillingAdd: '', //开票地址
          BillingTel: '', //电话
          BillingBank: '', //开户行
          BillingAccount: '', //账号
          BillingCnaps: '', //联行号
          ShareholderStruct: '', //股东结构
          parentCompany: '', //母公司id
          realCompanyName: '', //注册公司名称
          UserId: Cookies.get("userid-b"),
          SubType: 0,
          filelist: []
        },
        legForm2: {
          Id: '',
          LegalId: '', //legForm李的Id
          TaxpayerClass: '', //纳税人分类
          TaxAccounting: '', //报税会计
          TaxAccountingid: '',
          BillingOfficer: '', //开票负责人
          BillingOfficerid: '',
          TaxRebatePolicyUrl: '', //返税政策
          FinancialStatEKeeper: '', //审计管理员
          FinancialStatEkeeperid: '',
          Explain: '', //说明
          BaOpenBank: '', //开户行
          BaAccount: '', //账号
          BakIsDaf: '', //是否缺省
          BaIsShow: '', //是否隐藏
          AttachFinanStateUrl: '', //审计报告
          CommonAccount: [{
            BaOpenBank: '', //开户行
            BaAccount: '', //账号
            BakIsDaf: '', //是否缺省
            BaIsShow: '', //是否隐藏
          }]
        },
        imgtype: '',
        rules: {
          CompanyName: {
            required: true,
            message: "请输入公司名称",
            trigger: "blur",
          },
          parentCompany: {
            required: true,
            message: "请选择母公司",
            trigger: "change",
          },
          RegisteredCapital: {
            required: true,
            validator: validatetFund,
            trigger: ["blur", "change"],
          },
          TaxNum: {
            required: true,
            message: "请输入企业信用代码",
            trigger: "blur",
          },
          RegisteredAddress: {
            required: true,
            validator: validatetAddress,
            trigger: ["blur", "change"],
          },
          RegisteredTime: {
            required: true,
            message: "请选择注册时间",
            trigger: "change",
          },
          BusinessTerm: {
            required: true,
            validator: validatetTerm,
            trigger: ["blur", "change"],
          },
          LegalPerson: {
            required: true,
            message: "请选择法人/负责人",
            trigger: "change",
          },
        },
        provinces: [], //省市区
        propsAddress: {
          label: "Name",
          value: "Name",
          children: "children"
        },
        area: '', //省市区
        address: '', //地址
        dialogImageUrl: '',
        dialogVisiblePic: false,
        isExping: false,
        PicList1: [],
        PicList2: [],
        PicList3: [],
        PicList4: [],
        PicList5: [],
        PicList6: [],
        headPath: this.$store.state.EMP.docPath,
        personnelList: [], //人员列表
        roletype: localStorage.loginRoletype,
        isLongCheck:false,
        formData: {
          Id: '',
          LegalId: '',
          Name: '', //方案名称
          BillingType: '', //开票类型
          BillingContent: '', //开票内容
          TaxRate: '' //适用税率
        },
        showAdd: false,
        isSuccess: false, //是否保存成功
        longterm: false, //营业期限是否长期有效
        noFund: false, //无资金
        headPath: this.$store.state.EMP.docPath,
        showAddSys: false,
        FileType: '', //资质名称
        jgList: [],
        loading: false,
        zjTable: [{
          name: '营业执照',
          has: '',
          dateDue: '',
          Url: '',
          prop: 'BusiLicenseUrl',
        }, {
          name: '开户许可证',
          has: '',
          dateDue: '',
          Url: '',
          prop: 'OpenLicenseUrl',
        }, {
          name: '人力资源许可证',
          has: '',
          dateDue: '',
          Url: '',
          prop: 'HumanResoLicenUrl',
        }, {
          name: '劳务派遣证',
          has: '',
          dateDue: '',
          Url: '',
          prop: 'LaborlicenseUrl',
        }],
        ZJIndex: 0,
        showEditZJ: false, //编辑证件资料
        radio: '',
        radio2: '',
        formData2: {
          model: {
            Id: '',
            CompanyName: '', //公司名
            BillingIn: '', //开票会计内部
            BillingAgent: '', //开票会计代理
            InternalAccounting: '', //核算会计内部
            InternalAccountingAgent: '', //核算会计代理
            DeclarationCode: '', //申报密码
            RegistrationNum: '', //登记序号
            SystemCustomerNum: '', //财资系统客户号
          },
          BillingInValJ: [], //开票会计内部值
          BillingAgentValJ: [], //开票会计代理值
          InternalAccountingValJ: [], //核算会计内部值
          InternalAccountingAgentValJ: [], //核算会计代理值
          FinancialManagerJ: [], //财务经理
          CashierJ: [{
            Username: '',
            Userid: '',
            CashierType: '', //出纳业务
          }], //出纳
          BankAccountJ: [{ //银行帐户信息
            AccountName: '', //户名
            BankName: '', //银行名称
            OpeningBank: '', //开户行
            Account: '', //帐号
            IsDefault: 0, //是否缺省 0否 1是
            IsSalary: 0, //是否允许发薪 0否 1是
            IntPay: 0, //是否允许内部支付 0否 1是
          }],

        },
        permissionLists: [],
        branch: '', //分支机构
        showAddbranch: false,
        allLegList: [],
        isBtnLoading: false,
        branchName: '',
        legType: '',
        tableHeight: 0,
      }
    },
    created() {
      this.tableHeight = Number(document.body.clientHeight);
      if (this.$route.query.Id != undefined && this.$route.query.Id) {
        this.legForm.Id = this.$route.query.Id;
        this.legForm2.LegalId = this.$route.query.Id;
        this.legForm2.Id = this.$route.query.FinanceID
        this.getlegalsubjectdetails();
        this.type = 'edit'
      }
      this.getAllLegList();
      this.getButtonPower()
      this.getprovinces();
      this.getauthUserInfoByorgancode()
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let data = {
          path: '/legalMaintenance',
          powerEnName: 'system'
        }
        xz.getbtnPowerIdBypage(data).then(res => {
          // console.log('按钮',res)
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              resmsg.forEach(element => {
                this.permissionLists.push(element.Enname);
              });
              if (resmsg.length == 1 && resmsg[0].Enname == 'legalMaintenance_add_finance') {
                this.activeName = 'second';
                this.getlegalfinancedetails();
                this.getbslist();
                this.getCompfinanceSet();
              }
            } else {
              this.permissionLists = []
            }
          } else {
            this.permissionLists = []
          }
        })
      },
      changeb(val) {
        console.log(val)
      },
      //判断是否为空(包含0)
      isNull(o) {
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == 0 ||
          o == "NaN"
        );
      },
      //获取省市区
      getprovinces() {
        xz.getAreaAll().then((res) => {
          this.provinces = res
        })
      },
      //取人员列表
      getauthUserInfoByorgancode() {
        let data = {
          currpage: 1,
          perpage: 10000000,
          keyword: "",
          strWorkState: "",
          strstation: "",
          strorgancode: ""
        }
        xz.getauthUserInfoByorgancode(data).then(res => {
          if (res.status == "ok") {
            this.personnelList = [];
            res.msg.forEach(element => {
              let data = {
                Userid: element.Userid,
                Username: element.Username
              }
              this.personnelList.push(data)
            });
          } else {
            this.$message.error('获取人员列表失败')
            this.personnelList = [];
          }
        })
      },
      //获取基本信息
      getlegalsubjectdetails() {
        xz.getlegalsubjectdetails(this.legForm.Id).then(res => {
          if (res.status == 'ok') {
            this.legForm = res.data.entInfo1;
            this.zjTable[0].Url = res.data.entInfo1.BusiLicenseUrl;
            this.zjTable[1].Url = res.data.entInfo1.OpenLicenseUrl;
            this.zjTable[2].Url = res.data.entInfo1.HumanResoLicenUrl;
            this.zjTable[2].has = res.data.entInfo1.HasHumanResoLicen;
            this.zjTable[2].dateDue = res.data.entInfo1.HumanResoLicenEndTime;
            this.zjTable[3].Url = res.data.entInfo1.LaborlicenseUrl;
            this.zjTable[3].has = res.data.entInfo1.HasLaborlicense;
            this.zjTable[3].dateDue = res.data.entInfo1.LaborlicenseEndTime;
            if (res.data.entInfo1.RegisteredAddress != undefined && res.data.entInfo1.RegisteredAddress) {
              if (res.data.entInfo1.RegisteredAddress.indexOf('$$') > -1) {
                this.$nextTick(() => {
                  this.$refs[`regAddress`].inputValue = res.data.entInfo1.RegisteredAddress.split(';')[0].replace('$$', '');
                  this.$refs[`regAddress2`].inputValue = res.data.entInfo1.RegisteredAddress.split(';')[0].replace('$$', '');
                  this.address = res.data.entInfo1.RegisteredAddress.split(';')[1];
                })
                console.log(res.data.entInfo1.RegisteredAddress.split(';')[0].replace('$$', ''))
              } else {
                this.area = res.data.entInfo1.RegisteredAddress.split('/')[0].split(',');
                this.address = res.data.entInfo1.RegisteredAddress.split('/')[1];
              }

            }
            if (res.data.entInfo1.BusinessUnit != undefined && res.data.entInfo1.BusinessUnit) {
              this.legForm.BusinessUnit = res.data.entInfo1.BusinessUnit.split(',')
            }
            if (res.data.entInfo1.RegisteredCapital == 0) {
              this.noFund = true;
              this.legForm.RegisteredCapital = '';
            }
            if (res.data.entInfo1.BusinessTerm == '2999-12-31T00:00:00' || res.data.entInfo1.BusinessTerm == '2999-12-31') {
              this.longterm = true;
              this.legForm.BusinessTerm = '';
            }
            this.$set(this.legForm, 'filelist', res.data.filelist)
            let arr = ['BusiLicenseUrl', 'OpenLicenseUrl', 'HumanResoLicenUrl', 'LaborlicenseUrl'];
            for (let i = 0; i < 4; i++) {
              if (res.data[arr[i]]) {
                let item = 'PicList' + (i + 1);
                this[item] = [{
                  Id: new Date().valueOf().toString() + Math.random(),
                  url: this.headPath + res.data[arr[i]]
                }]
              }
            }
          }
        })
      },
      //获取财务信息
      getlegalfinancedetails() {
        xz.getlegalfinancedetails(this.legForm2.LegalId).then(res => {
          if (res.status == 'ok') {
            if (!this.isNull(res.data)) {
              res.data.BaIsShow = res.data.BaIsShow ? eval(res.data.BaIsShow) : false
              res.data.BakIsDaf = res.data.BakIsDaf ? eval(res.data.BakIsDaf) : false
              if (!this.isNull(res.data.CommonAccount)) {
                res.data.CommonAccount = eval(res.data.CommonAccount)
                this.legForm2 = res.data;
                this.legForm2.CommonAccount.forEach(element => {
                  element.BakIsDaf = element.BakIsDaf ? eval(element.BakIsDaf) : false
                  element.BaIsShow = element.BaIsShow ? eval(element.BaIsShow) : false
                });
              } else {
                this.legForm2 = res.data;
              }
              if (res.data.TaxRebatePolicyUrl) {
                this.PicList5 = [{
                  Id: new Date().valueOf().toString() + Math.random(),
                  name: res.data.TaxRebatePolicyUrl,
                  url: this.headPath + res.data.TaxRebatePolicyUrl
                }]
              }
            }
          }
        })
      },
      handleClick(tab, event) {
        if (this.activeName == 'first') {
          this.getlegalsubjectdetails();
        } else if (this.activeName == 'second') {
          this.getlegalfinancedetails();
          this.getbslist();
          //取公司财务设置
          this.getCompfinanceSet();
        } else {
          this.GetSubsidiaryCompanyList()
        }
      },
      previewImg(url) {
        this.srcList = [url]
      },
      changeAddress(val) {
        this.legForm.RegisteredAddress = '';
        // console.log(this.area.toString().split(','))
      },
      // 取消
      backHandle() {
        // this.$router.push({
        //   path: "/legalMaintenance",
        // });
        window.close()
      },
      handleChangePic1(file) { //上传营业执照
        this.imgtype = 'BusiLicenseUrl';
        this.compress(file);
      },
      handleChangePic2(file) { //上传开户许可证
        this.imgtype = 'OpenLicenseUrl';
        this.compress(file);
      },
      handleChangePic3(file) { //上传人力资源许可证
        this.imgtype = 'HumanResoLicenUrl';
        this.compress(file);
      },
      handleChangePic4(file) { //上传劳务许可证
        this.imgtype = 'LaborlicenseUrl';
        this.compress(file);
      },
      handleChangePic5(file) { //上传返税政策
        this.imgtype = 'TaxRebatePolicyUrl';
        this.compress(file);
      },
      handleChangePic6(file) { //上传审计报告
        this.imgtype = 'AttachFinanStateUrl';
        this.compress(file);
      },
      compress(file) {
        let maxSize = 1024 * 1024 * 5;
        if (file.size <= maxSize) {
          this.uploadImg(file.raw);
        } else { //压缩文件
          xz.imgCompress(file.raw).then((f) => {
            if (f) {
              this.uploadImg(f)
            }
          });
        }
      },
      uploadImg(file) {
        let formData = new FormData();
        formData.append("action", "save");
        formData.append("pagename", "bdocinf");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("entPicFile", file, file.name);
        xz.uploadCert(formData).then((res) => {
          console.log("entPicFile", res);
          if (res) {
            if (this.activeName == 'first') {
              this.legForm[this.imgtype] = res;
            } else {
              this.legForm2[this.imgtype] = res;
            }
          } else {
            this.$message("文件上传失败,请稍后再试");
          }
        });
      },
      //图片预览
      handlePictureCardPreview(file) {
        console.log(file);
        this.dialogImageUrl = file.url;
        this.dialogVisiblePic = true;
      },
      //删除
      handleRemovePic1() {
        this.legForm.BusiLicenseUrl = '';
      },
      handleRemovePic2() {
        this.legForm.OpenLicenseUrl = '';
      },
      handleRemovePic3() {
        this.legForm.HumanResoLicenUrl = '';
      },
      handleRemovePic4() {
        this.legForm.LaborlicenseUrl = '';
      },
      handleRemovePic5() {
        this.legForm.TaxRebatePolicyUrl = '';
      },
      handleRemovePic5() {
        this.legForm2.AttachFinanStateUrl = '';
      },
      handleExceedPic() {
        this.$message.warning(`最多上传1张图片！`);
      },
      handleExceed() {
        this.$message.warning(`最多上传1张pdf！`);
      },
      //提交基本信息
      submitForm() {
        this.$refs["legForm"].validate((valid) => {
          if (valid) {
            this.$refs["legForm2"].validate((valid2) => {
              if (valid2) {
                if (this.legForm.filelist.length > 0) {
                  this.legForm.filelist.forEach((e, index) => {
                    e.Sort = index + 1
                    e.FileName = index + 1
                  });
                }
                if (!this.isNull(this.area)) {
                  this.legForm.RegisteredAddress = this.area.toString() + '/' + this.address;
                } else {
                  this.legForm.RegisteredAddress = this.legForm.RegisteredAddress.split(';')[0] + ';' + this.address;
                }
                if (!this.isNull(this.legForm.BusinessUnit)) {
                  this.legForm.BusinessUnit = this.legForm.BusinessUnit.toString();
                } else {
                  this.legForm.BusinessUnit = ''
                }
                if (this.noFund) {
                  this.legForm.RegisteredCapital = 0
                }
                if (this.longterm) {
                  this.legForm.BusinessTerm = '2999-12-31'
                }
                this.legForm.BusiLicenseUrl = this.zjTable[0].Url;
                this.legForm.OpenLicenseUrl = this.zjTable[1].Url;
                this.legForm.HumanResoLicenUrl = this.zjTable[2].Url;
                this.legForm.HasHumanResoLicen = this.zjTable[2].has;
                this.legForm.HumanResoLicenEndTime = this.zjTable[2].dateDue;
                this.legForm.LaborlicenseUrl = this.zjTable[3].Url;
                this.legForm.HasLaborlicense = this.zjTable[3].has;
                this.legForm.LaborlicenseEndTime = this.zjTable[3].dateDue;
                this.legForm.UserId = Cookies.get("userid-b");
                this.isBtnLoading = true;
                xz.SRFun(this.legForm, 'SetSubsidiaryCompanySave').then(res => {
                  this.isBtnLoading = false;
                  if (res.status == 'ok') {
                    if (res.data) {
                      // console.log(res)
                      this.legForm.Id = res.data.LegalSubjectId;
                      this.legForm2.LegalId = res.data.LegalSubjectId;
                      this.legForm2.Id = res.data.LegalFinanceId;
                    }
                    this.$message.success('基本信息保存成功！')
                    this.isSuccess = true;
                    if (this.roletype.indexOf('adm') > -1) {
                      this.activeName = 'second';
                      if (this.type == 'edit') {
                        this.getlegalfinancedetails()
                      }
                    } else {
                      setTimeout(() => {
                        this.backHandle()
                      }, 300);
                    }
                  } else {
                    this.$message.error(res.msg)
                  }
                })
              }
            })
          }
        })
        // this.$refs["legForm"].validate((valid) => {})
      },
      //财务信息
      saveForm() {
        this.$refs["finance"].validate((valid) => {
          if (valid) {
            if (this.legForm2.CommonAccount == null || this.legForm2.CommonAccount == 'null' || !this.legForm2.CommonAccount == null) {
              this.legForm2.CommonAccount = []
              console.log(this.legForm2.CommonAccount)
            }
            this.legForm2 = JSON.parse(JSON.stringify(this.legForm2).replace(/CommonAccount/g, "CommonAccount1"));
            xz.updatelegalfinance(this.legForm2).then(res => {
              if (res.status == 'ok') {
                this.$message.success('财务信息保存成功！')
                this.legForm2 = JSON.parse(JSON.stringify(this.legForm2).replace(/CommonAccount1/g, "CommonAccount"));
                setTimeout(() => {
                  this.backHandle()
                }, 300);
              } else {
                this.$message.error('系统出错')
              }
            })
          }
        })

      },
      //选择人员
      changePerson(val, name, id) {
        this.legForm[id] = val.Userid;
        this.legForm[name] = val.Username;
      },
      changePerson2(val, name, id) {
        this.legForm2[id] = val.Userid;
        this.legForm2[name] = val.Username;
      },
      //获取方案列表
      getbslist() {
        let data = {
          LegafId: this.legForm2.LegalId
        }
        xz.getbslist(data).then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data
          }
        })
      },
      //添加方案
      addNew() {
        this.formData.LegalId = this.legForm2.LegalId;
        this.formData2.name = '';
        this.formData.BillingType = '';
        this.formData.BillingContent = '';
        this.formData.TaxRate = '';
        this.showAdd = true;
      },
      confirmAdd() {
        xz.updatebillingscheme(this.formData).then(res => {
          if (res.status == 'ok') {
            this.getbslist();
            this.showAdd = false;
            this.$message.success("保存成功")
          } else {
            this.$message.error("系统出错")
          }
        })
      },
      //添加一般户
      addHu() {
        if (!this.isNull(this.legForm2.CommonAccount)) {
          let item = {
            BaOpenBank: '', //开户行
            BaAccount: '', //账号
            BakIsDaf: '', //是否缺省
            BaIsShow: '', //是否隐藏
          }
          this.legForm2.CommonAccount.push(item)
        } else {
          this.$set(this.legForm2, 'CommonAccount', [])
          let item = {
            BaOpenBank: '', //开户行
            BaAccount: '', //账号
            BakIsDaf: '', //是否缺省
            BaIsShow: '', //是否隐藏
          }
          this.legForm2.CommonAccount.push(item)
        }
      },
      down(url) {
        let d = url.replace("\"", "").replace("\"", "");
        var path = this.headPath + d;
        const aTag = document.createElement('a')
        aTag.href = path
        aTag.click();
      },
      handleChangeUpload(file, fileList, index) {
        console.log(file, index)
        let formData = new FormData();
        formData.append("action", "save");
        formData.append("pagename", "bdocinf");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("entPicFile", file.raw, file.raw.name);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.legForm.filelist[index].Url = res;
            xz.updatefilemanage(this.legForm.filelist[index]).then(res => {
              if (res.status == 'ok') {
                this.$message.success('上传成功！')
              } else {
                this.$message.error('系统出错')
              }
            })
          } else {
            this.$message("文件上传失败,请稍后再试");
          }
        });
      },
      //上传证件附件
      handleChangeUploadZJ(file, fileList, index) {
        console.log(file, index)
        let formData = new FormData();
        formData.append("action", "save");
        formData.append("pagename", "bdocinf");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("entPicFile", file.raw, file.raw.name);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            // this.legForm[this.zjTable[index].prop] = res;
            this.zjTable[index].Url = res;
          } else {
            this.$message("文件上传失败,请稍后再试");
          }
        });
      },
      del(index) {
        this.legForm.filelist.splice(index, 1);
      },
      delUrl(row) {
        this.$set(row, 'Url', '')
        xz.updatefilemanage(row).then(res => {
          if (res.status == 'ok') {
            this.$message.success('附件删除成功！')
          } else {
            this.$message.error('系统出错')
          }
        })
      },
      //新增资质
      addZZ() {
        this.FileType = '';
        this.showAddSys = true
      },
      confirmAddSys() {
        let data = {
          BusinessId: this.legForm.Id,
          Url: '',
          Id: '',
          FileType: this.FileType,
          BusiType: '1',
          CompanyName: this.legForm.CompanyName
        }
        if (this.legForm.filelist != undefined && this.legForm.filelist) {
          this.legForm.filelist.push(data)
          this.showAddSys = false;
        } else {
          this.$set(this.legForm, 'filelist', [])
        }
      },
      //删除证件附件url
      delZJUrl(index) {
        // this.legForm[this.zjTable[index].prop] = '';
        this.zjTable[index].Url = ''
      },
      editZJ(row, index) {
        this.ZJIndex = index;
        this.showEditZJ = true;
      },
      confirmEditZJ() {
        console.log(this.zjTable)
        this.showEditZJ = false;
      },
      //新增
      addbankItem() {
        let data = {
          AccountName: '', //户名
          BankName: '', //银行名称
          OpeningBank: '', //开户行
          Account: '', //帐号
        }
        this.formData2.BankAccountJ.push(data)
      },
      //删除
      delbankItem(index) {
        this.formData2.BankAccountJ.splice(index, 1)
      },
      addLinkage(index) {
        if (this.formData2.BankAccountJ[index].LinkageList != undefined && this.formData2.BankAccountJ[index].LinkageList) {
          let data = {
            AccountName: '', //户名
            BankName: '', //银行名称
            OpeningBank: '', //开户行
            Account: '', //帐号
          }
          this.formData2.BankAccountJ[index].LinkageList.push(data)
          console.log('11', this.formData2.BankAccountJ[index].LinkageList)
        } else {
          this.$set(this.formData2.BankAccountJ[index], 'LinkageList', [])
          let data = {
            AccountName: '', //户名
            BankName: '', //银行名称
            OpeningBank: '', //开户行
            Account: '', //帐号
          }
          this.formData2.BankAccountJ[index].LinkageList.push(data)
          console.log('2', this.formData2.BankAccountJ[index].LinkageList)
        }
      },
      //删除联动账号
      delLinkageItem(index, i) {
        this.formData2.BankAccountJ[index].LinkageList.splice(i, 1)
      },
      //取公司财务设置
      getCompfinanceSet() {
        xz.getCompfinanceSet(this.legForm.CompanyName, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.formData2.model = res.data.dbjls;
            this.formData2.BillingInValJ = res.data.BillingInValJ;
            this.formData2.BillingAgentValJ = res.data.BillingAgentValJ;
            this.formData2.InternalAccountingValJ = res.data.InternalAccountingValJ;
            this.formData2.FinancialManagerJ = res.data.FinancialManagerJ;
            if (!res.data.CashierJ) {
              this.formData2.CashierJ = [{
                Username: '',
                Userid: '',
                CashierType: '', //出纳业务
              }]
            } else {
              this.formData2.CashierJ = res.data.CashierJ;
            }
            if (!res.data.BankAccountJ) {
              this.formData2.BankAccountJ = [{ //银行帐户信息
                AccountName: '', //户名
                BankName: '', //银行名称
                OpeningBank: '', //开户行
                Account: '', //帐号
                IsDefault: 0, //是否缺省 0否 1是
                IsSalary: 0, //是否允许发薪 0否 1是
                IntPay: 0, //是否允许内部支付 0否 1是
              }]
            } else {
              res.data.BankAccountJ.forEach(element => {
                // element.LinkageList = '';IsBasic;
                element.IsCbs = Number(element.IsCbs);
                element.IsDefault = Number(element.IsDefault);
                element.IsSalary = Number(element.IsSalary);
                element.IntPay = Number(element.IntPay);
              });
              this.formData2.BankAccountJ = res.data.BankAccountJ;
            }
          } else {
            this.$message.error('系统出错')
          }
        })
      },
      changeRadio() {
        this.BillingInValJ = [];
        this.BillingAgentValJ = [];
      },
      changeRadio2() {
        this.InternalAccountingValJ = [];
        this.InternalAccountingAgentValJ = [];
      },
      //新增
      addCashier() {
        let data = {
          Username: '',
          Userid: '',
          CashierType: '',
        }
        this.formData2.CashierJ.push(data)
      },
      //删除
      delCashier(index) {
        this.formData2.CashierJ.splice(index, 1)
      },
      //选择出纳
      changeCashier(val, index) {
        this.formData2.CashierJ[index].Username = val.Username;
        this.formData2.CashierJ[index].Userid = val.Userid;
      },
      //保存
      confirmAddSalary() {
        delete this.formData2.model.CreateTime;
        delete this.formData2.model.UpdataTime;
        this.formData2.model.DeclarationCode = encodeURIComponent(this.formData2.model.DeclarationCode)
        xz.addCompfinanceSet(this.formData2, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.getCompfinanceSet();
            this.$message.success('保存成功');
          } else {
            this.$message.error(res.msg);
          }
        })
      },
      //获取企业登记序号
      getSerial() {
        xz.getreqseq({
          certid: this.legForm.TaxNum
        }).then(res => {
          console.log(res)
          if (res.status == 'ok') {
            this.formData2.model.RegistrationNum = res.msg;
          } else {
            this.$message.error('获取登记序号出错')
          }
        })
      },
      //获取分支机构列表
      GetSubsidiaryCompanyList() {
        let str = `GetSubsidiaryCompanyList?ParentCompanyId=${this.legForm.Id}&CompanyName=${this.branchName}`;
        this.loading = true;
        xz.SRGetFun(str, 'GET').then(res => {
          if (res.status == 'ok') {
            this.jgList = res.data;
            this.jgList.forEach(element => {
              element.businessTerm = this.dueDays(element.businessTerm)
              element.humanResoLicenEndTime = this.dueDays(element.humanResoLicenEndTime)
              element.laborlicenseEndTime = this.dueDays(element.laborlicenseEndTime)
            });
            this.allLegList = this.allLegList.filter(item => {
              const notInJgList = !this.jgList.some(jgItem => jgItem.id === item.Id);
              const containsCompanyName = item.CompanyName.includes(this.legForm.CompanyName) && this.legForm.CompanyName != item.CompanyName;
              return notInJgList && containsCompanyName;
            });
          } else {
            this.jgList = [];
          }
          this.loading = false;
        })
      },
      dueDays(date) {
        if (date) {
          if (date.indexOf('2999-12-31') > -1) {
            return '长期有效'
          } else {
            let days = ((new Date(date).valueOf() - new Date().valueOf()) / (24 * 60 * 60 * 1000))
            return days
          }
        } else {
          return ''
        }
      },
      getAllLegList() {
        let d = {
          CompanyName: '',
          BusinessUnit: '',
          HasHumanResoLicen: '',
          HasLaborlicense: '',
          BillingType: '',
          LaborlicenseUrl: '',
          RegisteredAddress: '',
          pageNum: 1,
          pageSize: 100000
        }
        xz.getlegalsubjectlist(d).then(res => {
          if (res.status == 'ok') {
            this.allLegList = res.data.data;
          } else {
            this.tableData = [];
          }
        })
      },
      addBranch() {
        this.branch = '';
        this.showAddbranch = true;
      },
      confirmAddbranch() {
        if (this.branch) {
          this.isBtnLoading = true;
          let d = {
            parentCompany: this.legForm.Id,
            id: this.branch
          }
          xz.SRFun(d, 'SetBindParentCompanySave').then(res => {
            if (res.status == 'ok') {
              this.GetSubsidiaryCompanyList();
              this.$message.success('保存成功');
              this.showAddbranch = false;
            } else {
              this.$message.error(res.msg);
            }
            this.isBtnLoading = false;
          })
        } else {
          this.$message.warning('请选择要添加的分支机构')
        }
      },
      changeLeg(val) {
        // if (val) {
        //   let str = `GetSubsidiaryCompanyEdit?ParentCompanyId=${val}`;
        //   xz.SRGetFun(str, 'GET').then(res => {
        //     if (res.status == 'ok') {
        //       this.legForm.BusinessScope = res.data.businessScope;
        //       this.legForm.BusinessUnit = res.data.businessUnit;
        //       this.legForm.CompanyPro = res.data.companyPro;
        //       this.legForm.RegisteredCapital = res.data.registeredCapital;
        //       this.legForm.RegisteredTime = res.data.registeredTime;
        //     } else {
        //       this.$message.error("获取母公司信息失败")
        //     }
        //   })
        // }
      },
      delBranch(row) {
        let str = `SetSubsidiaryCompanyDelete?id=${row.id}`;
        xz.SRGetFun(str, 'DELETE').then(res => {
          if (res.status == 'ok') {
            this.GetSubsidiaryCompanyList();
            this.$message.success('删除成功');
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      longChange(val) {
        if (val) {
          this.zjTable[this.ZJIndex].dateDue = '2999-12-31';
        }else{
          this.zjTable[this.ZJIndex].dateDue = '';
        }
      },
      exportHandle() {
        this.isExping = true;
        let d = {
          parentCompanyId: this.legForm.Id,
          companyName: this.branchName,
          filename: '分支机构列表导出.xlsx'
        }
        xz.SREXPFun(d, 'ExportedSubsidiaryCompany/download').then(res => {
          if (res) {
            try {
              var data = new Blob([res], {
                type: "application/vnd.ms-excel;charset=utf-8"
              });
              var downloadUrl = window.URL.createObjectURL(data);
              var anchor = document.createElement("a");
              anchor.href = downloadUrl;
              anchor.download = "分支机构列表导出.xlsx";
              anchor.click();
              window.URL.revokeObjectURL(data);
              this.isExping = false;
            } catch (e) {
              this.isExping = false;
              this.$message.error('导出异常')
            }
          } else {
            this.isExping = false;
            this.$message.error('导出异常')
          }
        })
      },
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    width: 98%;
    margin-bottom: 16px;
  }

  .info_Box_left {
    width: 50%;
    max-width: 500px;
    padding: 10px 30px 10px 10px;
  }

  .info_item_sys {
    color: #598DE7;
  }

  .legForm {
    /* width: 1000px; */
    width: 500px;
  }

  .btnBox {
    margin-top: 20px;
    padding: 20px 0 50px 0;
    width: 1070px;
    display: flex;
    justify-content: center;
  }

  .info_Item_Title {
    padding-top: 10px;
    line-height: 33px;
    font-family: "微软雅黑 Bold", "微软雅黑 Regular", 微软雅黑, sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 14px;
    margin-right: 100px;
  }

  .f_form {
    border-top: 1px solid #ddd;
  }

  .yyzz {
    font-size: 14px;
    margin-right: 15px;
  }

  .flname1 {
    height: 40px;
    line-height: 40px;
    margin-right: 10px;
  }

  .greenName {
    margin-top: 10px;
  }

  .bankTitle {
    font-size: 14px;
    color: #333;
    font-weight: bold;
    margin-bottom: 5px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .bankInfo_title {
    width: 50px;
    font-size: 14px;
    line-height: 40px;
    text-align: right;
    padding-right: 5px;
  }

  .bankInfo {
    margin-bottom: 10px;
  }

  .formTitle {
    margin-right: 10px;
  }

  .CashierBox {
    margin-bottom: 10px;
  }

  .warning {
    color: red;
  }

  .bankBox {
    overflow-x: auto;
  }

  .bankAccoutBox {
    flex-wrap: nowrap;
  }
</style>
<style>
  .page_legalSubjectInfo .re_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_legalSubjectInfo .re_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .legForm .el-input__inner,
  .legForm .el-date-editor.el-input,
  .legForm .el-date-editor.el-input__inner {
    width: 300px;
  }

  .legForm .unit .el-input__inner,
  .legForm .unit .el-input {
    width: 200px;
  }

  .legForm .address .el-input__inner {
    width: 200px;
  }

  .legForm .el-textarea__inner,
  .legForm .el-textarea {
    width: 300px;
  }

  .yyzzp .el-upload--picture-card {
    width: 100px;
    height: 100px;
    line-height: 110px;
  }

  .page_legalSubjectInfo .el-upload-list__item-name {
    width: 300px;
  }

  .bankInfo .el-checkbox {
    margin-right: 10px;
  }

  .page_legalSubjectInfo .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_legalSubjectInfo .bankAccoutBox .el-checkbox {
    margin-right: 15px;
  }

  .page_legalSubjectInfo .bankAccoutBox .el-checkbox__label {
    padding-left: 5px;
  }

  .page_legalSubjectInfo .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .page_legalSubjectInfo .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_legalSubjectInfo .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }
</style>